import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import snackBarReducer from "./snackBarSlice"
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {persistStore, persistReducer, FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,} from 'redux-persist';
import {combineReducers} from 'redux';
import chatReducer from './chatSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['chat', 'user'], // Persist both chat and user reducers
};

const rootReducer = combineReducers({
  user: userReducer,
  snackBar: snackBarReducer,
  chat: chatReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore redux-persist actions
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        },
      }),
});

export const persistor = persistStore(store);
